var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 39,
    viewBox: "0 0 34 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17865",
    "data-name": "Group 17865",
    transform: "translate(-1121 -377.792)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_203",
    "data-name": "Group 203",
    transform: "translate(1121 377.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_3",
    "data-name": "Subtraction 3",
    d: "M6,39A1.092,1.092,0,0,1,4.91,37.909V16.842A5.748,5.748,0,0,1,0,11.29,5.747,5.747,0,0,1,4.91,5.738V1.091a1.091,1.091,0,0,1,2.182,0V5.738A5.747,5.747,0,0,1,12,11.29a5.747,5.747,0,0,1-4.909,5.552V37.909A1.092,1.092,0,0,1,6,39ZM6,7.184A4.246,4.246,0,0,0,1.636,11.29,4.245,4.245,0,0,0,6,15.395a4.245,4.245,0,0,0,4.363-4.1A4.245,4.245,0,0,0,6,7.184Z",
    transform: "translate(0 -0.208)",
    fill: "#636a77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_2",
    "data-name": "Subtraction 2",
    d: "M6,39A1.092,1.092,0,0,1,4.91,37.909V33.775a5.594,5.594,0,0,1,0-11.1V1.091a1.091,1.091,0,0,1,2.182,0V22.672a5.594,5.594,0,0,1,0,11.1v4.134A1.092,1.092,0,0,1,6,39ZM6,24.118a4.113,4.113,0,1,0,0,8.211,4.113,4.113,0,1,0,0-8.211Z",
    transform: "translate(10 -0.208)",
    fill: "#636a77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_1",
    "data-name": "Subtraction 1",
    d: "M6,39A1.092,1.092,0,0,1,4.91,37.909V20.947A5.748,5.748,0,0,1,0,15.395,5.747,5.747,0,0,1,4.91,9.842V1.091a1.091,1.091,0,0,1,2.182,0V9.842A5.747,5.747,0,0,1,12,15.395a5.747,5.747,0,0,1-4.909,5.552V37.909A1.092,1.092,0,0,1,6,39ZM6,11.29a4.245,4.245,0,0,0-4.364,4.1A4.246,4.246,0,0,0,6,19.5a4.245,4.245,0,0,0,4.363-4.106A4.245,4.245,0,0,0,6,11.29Z",
    transform: "translate(22 -0.208)",
    fill: "#636a77"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/share-icon.7e04b4a8b2da6e68f6e71311e862dfc2.svg";
export { ForwardRef as ReactComponent };